import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
import { StoreManagementDeliveryStoreActivationJobCreateParams } from '@/services/StoreManagement/DeliveryStoreActivationJobs/hooks/create/useStoreManagementDeliveryStoreActivationJobCreate';
import {
  StoreManagementDeliveryStoreActivationJobLatestParams,
  StoreManagementDeliveryStoreActivationJobLatestResponse,
} from '@/services/StoreManagement/DeliveryStoreActivationJobs/hooks/latest/useStoreManagementDeliveryStoreActivationJobLatest';
import { StoreManagementDeliveryStoreActivationJobUpdateParams } from '@/services/StoreManagement/DeliveryStoreActivationJobs/hooks/update/useStoreManagementDeliveryStoreActivationJobUpdate';

interface Interface {
  create: (
    params: StoreManagementDeliveryStoreActivationJobCreateParams
  ) => Promise<void>;
  update: (
    id: string,
    params: StoreManagementDeliveryStoreActivationJobUpdateParams
  ) => Promise<void>;
}

export class StoreManagementDeliveryStoreActivationJobsService
  implements Interface
{
  constructor(private readonly restClient: RestClientInterface) {}

  public async latest(
    params: StoreManagementDeliveryStoreActivationJobLatestParams
  ): Promise<StoreManagementDeliveryStoreActivationJobLatestResponse> {
    const queryParams = new URLSearchParams();
    queryParams.append('delivery_store_id', String(params.delivery_store_id));
    return await this.restClient.get<StoreManagementDeliveryStoreActivationJobLatestResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/delivery-store-activation-jobs/latest?${queryParams.toString()}` as const
    );
  }

  public async create(
    params: StoreManagementDeliveryStoreActivationJobCreateParams
  ): Promise<void> {
    return await this.restClient.post<
      StoreManagementDeliveryStoreActivationJobCreateParams,
      void
    >(
      `${TABLET_API_ORIGIN}/dashboard-api/delivery-store-activation-jobs` as const,
      params
    );
  }

  public async update(
    id: string,
    params: StoreManagementDeliveryStoreActivationJobUpdateParams
  ): Promise<void> {
    return await this.restClient.patch(
      `${TABLET_API_ORIGIN}/dashboard-api/delivery-store-activation-jobs/${id}` as const,
      params
    );
  }
}
